import { render, staticRenderFns } from "./ReportIssues.vue?vue&type=template&id=3f2bc00c&scoped=true"
import script from "./ReportIssues.vue?vue&type=script&lang=js"
export * from "./ReportIssues.vue?vue&type=script&lang=js"
import style0 from "./ReportIssues.vue?vue&type=style&index=0&id=3f2bc00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2bc00c",
  null
  
)

export default component.exports